/* DSL Birthday discount — als customer.metafields.dsl.birthday matched vandaag, toon banner */
(function(){
  var bday = (window.DSL_CUSTOMER && window.DSL_CUSTOMER.birthday) || "";
  if (!bday) return;
  var today = new Date();
  var parts = bday.split("-"); // YYYY-MM-DD or MM-DD
  if (parts.length < 2) return;
  var bMonth = parseInt(parts[parts.length-2], 10);
  var bDay = parseInt(parts[parts.length-1], 10);
  if (today.getMonth()+1 !== bMonth || today.getDate() !== bDay) return;
  var KEY = "dsl_bday_seen_" + today.getFullYear();
  if (sessionStorage.getItem(KEY)) return;
  sessionStorage.setItem(KEY, "1");
  if (window.DSL_BANNER) window.DSL_BANNER.show({text: "🎂 Gefeliciteerd! Gebruik code <strong>BIRTHDAY15</strong> voor 15% korting (vandaag geldig).", variant: "success", duration: 12000});
  if (window.DSL_AB) window.DSL_AB.track("birthday_show", {});
})();